import { showLoader } from '../../../actions/main-actions'
import store from 'store2'
import { isStaff, makeKey, roundPrice } from '../../../utils'
import { useDispatch } from 'react-redux'
import API from 'api'
import useStep from './useStep'
import { convertCurrency } from '../../helpers'
import { trackEvent, trackGA4Ecommerce } from '../../../gtm'
import md5 from 'md5'
import { toast } from 'react-toastify'

function trackCheckoutComplete({ dueNowData, data, duration, numberOfDivers }) {
  const totalUSDPrice = roundPrice(
    convertCurrency(dueNowData?.amountTotal, dueNowData?.currency, 'USD'),
  )

  trackEvent({
    checkout_order_id: data.reference,
    user_email_md5: data.email && md5(data.email),
    checkout_order_amount: totalUSDPrice,
  })

  const actionField = {
    transaction_id: data.reference,
    affiliation: data.affiliateId ? data.affiliateId : '',
    value: Number(convertCurrency(dueNowData?.taxFreeAmount, dueNowData?.currency, 'USD').toFixed(2)),
    tax: dueNowData?.taxesAmount,
    payment_type: '',
    coupon: data.appliedCoupon,
    number_of_divers: numberOfDivers,
    number_of_nights: duration,
  }

  if(data.appliedCoupon) {
    actionField.coupon = data.appliedCoupon
  }

  trackGA4Ecommerce(
    'purchase',
    {
      currency: 'USD',
      ...actionField,
      items: store.session.get('ecommerce'),
    },
    'PADI Travel - Liveaboards',
  )
  store.session.remove('ecommerce')
}

export default function useCheckoutForm(
  uuid,
  referrer,
  dueNowData,
  setOrder,
  requirements,
  duration,
  numberOfDivers,
  affiliateId,
) {
  const { setStep } = useStep()

  const dispatch = useDispatch()

  const sendForm = (values) => {
    const captcha = window.grecaptcha && window.grecaptcha.getResponse()
    if(!captcha) {
      return toast.error('Captcha is required', { position: 'top-center' })
    }
    const recaptcha = makeKey(captcha)
    dispatch(showLoader(true))
    if(uuid) {
      API(`checkout/orders/${uuid}/update/`)
        .put({
          ...values,
          ...dueNowData.payload,
          referrer,
          recaptcha,
          uuid,
          affiliateId: values.affiliateId || affiliateId,
        })
        .then((data) => {
          if(referrer) {
            window.location.href = referrer
          } else {
            data.orderUpdated = true
            setOrder({
              ...data,
              requirements,
            })
          }
          store.session.remove('diviac.referrer')
          store.session.remove('diviac.order_uuid')
          store.session.set('exitPopup', true)
          try {
            trackCheckoutComplete({
              dueNowData,
              data,
              duration,
              numberOfDivers,
            })
          } catch (e) {
            console.error(e)
          }
        })
        .then(() => {
          setStep(5)
        })
        .catch(() => {
          window.grecaptcha.reset()
        })
        .finally(() => {
          dispatch(showLoader(false))
        })
    } else {
      API(isStaff() ? 'checkout/staff/' : 'checkout/')
        .post({
          ...dueNowData.payload,
          ...values,
          recaptcha,
          affiliateId: values.affiliateId || affiliateId,
        })
        .then((data) => {
          setOrder({
            ...data,
            requirements,
          })
          setStep(5)
          store.session.set('exitPopup', true)
          try {
            trackCheckoutComplete({
              dueNowData,
              data,
              duration,
              numberOfDivers,
            })
          } catch (e) {
            console.error(e)
          }
          if(isStaff()) {
            window.location.href = `${process.env.INTRANET_URL}/booking-list/?order_id=${data.id}&tab=Internal`
          }
        })
        .then(() => {
          setStep(5)
        })
        .catch(() => {
          window.grecaptcha.reset()
        })
        .finally(() => {
          dispatch(showLoader(false))
        })
    }
  }

  return { sendForm }
}
